import BaseModel from './BaseModel'
import i18n from '@/plugins/i18n'

export default class Notification extends BaseModel {
    resourceName() {
        return 'notifications'
    }

    fields() {
        return [
            'id',
            'title',
            'description',
            'type',
            'days',
            'when',
            'action',
            'status',
            'created_at',
            'updated_at',
            'deleted_at',
        ]
    }

    dates() {
        return {
            created_at: 'YYYY-MM-DD HH:mm:ss',
            updated_at: 'YYYY-MM-DD HH:mm:ss',
            deleted_at: 'YYYY-MM-DD HH:mm:ss',
        }
    }

    get exibition() {
        return this.when === 'on_day'
            ? `No dia do ${i18n.t(
                  `resources.notification.actions.${this.action}`,
              )}`
            : `${this.days} dia(s) ${i18n.t(
                  `resources.notification.when.${this.when}`,
              )} do ${i18n.t(`resources.notification.actions.${this.action}`)}`
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.notification.attributes.title'),
                value: 'title',
                sortable: false,
            },
            {
                text: i18n.t('resources.notification.attributes.exibition'),
                value: 'exibition',
                sortable: false,
            },
            {
                text: i18n.t('resources.notification.attributes.status'),
                value: 'status',
                sortable: false,
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }

    get actions() {
        return [
            {
                type: 'edit',
                to: {
                    name: 'notifications.edit',
                    params: { id: this.id },
                },
            },
            {
                type: 'delete',
                hide: this.deleted,
            },
            {
                type: 'restore',
                hide: !this.deleted,
            },
        ]
    }
}
